import React, { Component } from 'react';
import { connect } from 'react-redux';
import { css } from '@emotion/core';
import { FaSpinner } from 'react-icons/fa';

import Button from '../../../shared/Button/Button';
import CheckboxContainer from '../../../shared/FormFields/CheckboxContainer';
import { saveNewsletter } from '../../../../redux/modules/newsletter';
import IubendaCookieSolution from '../../../../utils/iubenda';

import './Newsletter.scss';

class Newsletter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      privacy: false,
    };
  }

  handleChangeEmail = event => {
    this.setState({
      email: event.target.value,
    });
  };

  handleChangePrivacy = event => {
    this.setState({
      privacy: event.target.checked,
    });
  };

  saveNewsletter = event => {
    const { hasIubendaCookieSolution, iubendaApiKey } = this.props;
    if (hasIubendaCookieSolution) {
      const iubenda = new IubendaCookieSolution(
        hasIubendaCookieSolution,
        iubendaApiKey
      );
      iubenda.saveConsentNewsletter(this.state.email);
    }

    event.preventDefault();
    this.props.saveNewsletter(this.state.email);
  };

  render() {
    const {
      loading,
      iscritto,
      error,
      primaryColor,
      secondaryColor,
      newsletterTitle,
      isFullWidth,
      blogNewsletterVersion,
    } = this.props;
    const { email } = this.state;

    const newsLetterStyle = css`
      &.version-1 {
        background-color: ${secondaryColor};
        &.boxed {
          @media (min-width: 992px) {
            // height: 362px;
            height: 100%;
          }
        }
      }

      &.version-3 {
        background-color: ${primaryColor};
        &.boxed {
          @media (min-width: 992px) {
            // height: 362px;
            height: 100%;
          }
        }
      }

      &.version-1 {
        background-color: ${secondaryColor};
        form {
        }
      }

      &.version-2 {
        background-color: ${primaryColor};
        background-image: url('/static/images/dotted-background.png');
        background-size: cover;
        &.boxed {
          @media (min-width: 992px) {
            // height: 427px;
            height: 100%;
            margin-left: 15px;
          }
        }
        & h3 {
          text-align: center;
        }

        form {
          align-items: center !important;
          .subtitle {
            text-align: center;
            width: 75%;
          }
          .btn {
            background-color: #222222;
            height: 38px;
            max-width: 160px;
            width: 50%;
            margin-top: 28px;
            @media (max-width: 992px) {
              margin-top: 10px;
            }

            padding: 14px 11px;
            display: flex;
            align-self: center;
          }
        }

        form {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
        }
      }

      &.full-width {
        margin-top: 0;

        @media (min-width: 992px) {
          margin-top: 0;
          min-height: auto;
        }

        h3 {
          text-align: center;
        }

        form {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;

          @media (min-width: 992px) {
            // flex-direction: row;
            align-items: center;
            justify-content: space-between;
          }

          .subtitle,
          .privacy {
            flex: 1;
          }
          .email-input {
            flex: 2;
          }

          .subtitle,
          .email-input input,
          .checkbox {
            @media (min-width: 992px) {
              margin: 0;
            }
          }

          .email-input {
            @media (min-width: 992px) {
              margin: 0 50px 0 40px;
            }
          }
        }
      }
    `;

    return (
      <div
        className={`newsletter ${
          isFullWidth ? 'full-width' : 'boxed'
        } version-${blogNewsletterVersion}`}
        css={newsLetterStyle}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            color: '#fff',
            maxWidth: '100%',
            wordBreak: 'break-word',
            fontWeight: 'bold',
            fontSize: 24,
            marginBottom: 24,
          }}
        >
          {newsletterTitle || 'Iscriviti alla Newsletter'}
        </div>
        <form id="form_newsletter" onSubmit={this.saveNewsletter}>
          {!newsletterTitle && (
            <h3 className="subtitle">
              Resta aggiornato sulle offerte riservate ai nostri clienti.
            </h3>
          )}
          <div className="email-input">
            <input
              type="email"
              className="form-control"
              placeholder="Inserisci la tua Email"
              value={email}
              onChange={this.handleChangeEmail}
            />
            {this.props.blogNewsletterVersion !== 2 ? (
              <Button
                type="submit"
                className="btn btn-primary btn-thick"
                disabled={!this.state.email || !this.state.privacy}
              >
                {!!loading && <FaSpinner className="pulse" />}
                <span>Invia</span>
              </Button>
            ) : null}
          </div>
          <CheckboxContainer className="privacy">
            <input
              className="form-control"
              type="checkbox"
              id="privacy"
              name="privacy"
              checked={this.state.privacy}
              onChange={this.handleChangePrivacy}
            />
            <label htmlFor="privacy">
              Dichiaro di volermi iscrivere alla newsletter per ricevere
              comunicazioni commerciali
            </label>
          </CheckboxContainer>
          {this.props.blogNewsletterVersion === 2 ? (
            <Button
              type="submit"
              className="btn btn-primary btn-thick"
              disabled={!this.state.email || !this.state.privacy}
            >
              {!!loading && <FaSpinner className="pulse" />}
              <span>Invia</span>
            </Button>
          ) : null}
        </form>
        {!!error && (
          <div className="alert alert-danger">
            È avvenuto un errore durante il salvataggio. Riprova più tardi.
          </div>
        )}
        {!!iscritto && (
          <div className="alert alert-success">
            Iscrizione avvenuta correttamente. Grazie!
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.newsletter.loading,
    iscritto: state.newsletter.iscritto,
    error: state.newsletter.error,
    uiVariantInputText: state.store.data.uiVariants.inputText,
    home: state.store.data.home,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    iubendaApiKey: state.store.data.integrazioni.iubenda.apiKey,
  };
}

export default connect(mapStateToProps, { saveNewsletter })(Newsletter);
